import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function BeginYourExperience() {
  return <section data-section-id="226206" id="bereit-für-veränderung" className="bg-muted text-foreground relative flex min-h-[60vh] items-center justify-center overflow-hidden py-24 sm:py-32 lg:py-40">
      {}
      <div className="absolute inset-0 pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/dark_grain_noise_texture.png)] bg-repeat opacity-[0.02] mix-blend-overlay" aria-hidden="true" />
      <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/hands_image.png" alt="" className="absolute inset-0 h-full w-full object-cover opacity-30 pointer-events-none" aria-hidden="true" />

      <div className="container relative z-10 mx-auto px-4 text-center">
        <div className="mx-auto max-w-3xl">
          <h2 className="font-default tracking-tighter text-foreground !font-normal !text-[52px]">
            Bereit für Deine Veränderung?
          </h2>
          
          <p className="mt-6 font-sans text-lg tracking-wide text-muted-foreground sm:text-xl">
            Dein Weg zu ganzheitlichem Wohlbefinden und strahlendem Aussehen beginnt hier.
          </p>

          <div className="mt-12 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-6">
            <Button variant="ghost" size="lg" className="w-full text-sm tracking-widest text-muted-foreground uppercase sm:w-auto rounded-lg" asChild>
              <Link to="https://wa.me/491713617469" target="_blank">Kostenloses Erstgespräch</Link>
            </Button>
            
            <Button variant="default" size="lg" className="w-full text-base font-medium tracking-wide sm:w-auto rounded-lg shadow-lg shadow-accent/50 transition-all hover:shadow-xl hover:shadow-accent/60" asChild>
              <Link to="https://wa.me/491713617469" target="_blank">Termin vereinbaren</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}